import Button, {ButtonProps} from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import {PaymentMethod} from '@stripe/stripe-js'
import ErrorAlert from 'lib/ui/alerts/ErrorAlert'
import {api} from 'lib/url'
import SaveCreditCardForm from 'lib/stripe/SaveCreditCardForm'
import {useDefaultPaymentMethod} from 'obvio/Billing/DefaultPaymentMethodProvider'
import {teamMemberClient} from 'obvio/obvio-client'
import React, {useState} from 'react'

type NewCardFormProps = {
  className?: string
  disableAutoHide?: boolean
}

export default function NewCardForm(props: NewCardFormProps) {
  const [showingForm, setShowingForm] = useState(false)
  const {paymentMethod} = useDefaultPaymentMethod()

  const handleComplete = () => {
    if (props.disableAutoHide) {
      return
    }

    setShowingForm(false)
  }

  const label = paymentMethod ? 'Change Default Card' : 'Add Default Card'
  const buttonVariant: ButtonProps['variant'] = paymentMethod
    ? 'outlined'
    : 'contained'

  if (!showingForm) {
    return (
      <Button
        variant={buttonVariant}
        onClick={() => setShowingForm(true)}
        color="primary"
        aria-label="card button"
      >
        {label}
      </Button>
    )
  }

  return <Content {...props} onComplete={handleComplete} />
}

function Content(props: NewCardFormProps & {onComplete: () => void}) {
  const {setPaymentMethod} = useDefaultPaymentMethod()
  const [error, setError] = useState<string | null>(null)
  const clearError = () => setError(null)
  const savePaymentMethod = useSavePaymentMethod()
  const {onComplete} = props

  const handlePaymentMethod = (paymentMethodId: string | PaymentMethod) => {
    clearError()

    savePaymentMethod(paymentMethodId)
      .then((paymentMethod) => {
        setPaymentMethod(paymentMethod)
        onComplete()
      })
      .catch((e) => setError(e.message))
  }

  return (
    <>
      <ErrorAlert onClose={clearError}>{error}</ErrorAlert>
      <SaveCreditCardForm
        className={props.className}
        submitLabel="Save Card"
        onSuccess={handlePaymentMethod}
      />
    </>
  )
}

function useSavePaymentMethod() {
  return (paymentMethodId: string | PaymentMethod) => {
    const url = api('/stripe/default_payment_method')

    return teamMemberClient.put<PaymentMethod>(url, {
      payment_method_id: paymentMethodId,
    })
  }
}

export function Loader() {
  return (
    <CircularProgress
      size={18}
      thickness={6}
      value={100}
      variant="indeterminate"
      color="primary"
    />
  )
}
